//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FilterNav from './FilterNav.vue';

export default {
	name: 'FilterBar',

	components: { FilterNav: FilterNav },

	props: {
		filters: {
			type: Array,
			default: function _default() {
				return [];
			}
		},

		count: {
			type: String,
			required: true
		}
	},

	data: function data() {
		return {
			openNavIndex: null
		};
	},


	methods: {
		toggleNav: function toggleNav(index) {
			this.openNavIndex = index === this.openNavIndex ? null : index;
		},
		closeNav: function closeNav() {
			this.openNavIndex = null;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FilterBar.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FilterBar.vue
// module chunks = 0